import { createModalSlice, modalActions, modalSelectors } from './slices/modal'
import type { FullStore } from './slices/types'

import { create } from 'zustand'

export type * from './slices/modal'
export type { FullStore } from './slices/types'

export const useModalStore = create((set) => ({
    ...createModalSlice(set),
}))

export const getModalStore = () => useModalStore.getState() as FullStore

export { modalActions, modalSelectors }
